import { Component, OnInit } from '@angular/core';
//import embed, {Mode, VisualizationSpec} from 'vega-embed';


export enum GOOGLE_CHART_TYPE
{
    'LINE' = 'LINE',
    'PIE' = 'PIE',
    'AREA' = 'AREA',
    'SCATTER' = 'SCATTER'
}

@Component({
  selector: 'gp-poc',
  templateUrl: './poc.component.html',
  styleUrls: ['./poc.component.scss']
})
export class PocComponent implements OnInit {

  

  selectedChartType = GOOGLE_CHART_TYPE.LINE;
  charts = [
    {chartType: GOOGLE_CHART_TYPE.LINE, desc: 'Line'},
    {chartType: GOOGLE_CHART_TYPE.PIE, desc: 'Pie'},
    {chartType: GOOGLE_CHART_TYPE.AREA, desc: 'Area'},    
    {chartType: GOOGLE_CHART_TYPE.SCATTER, desc: 'Scatter'},         
  ];

  constructor() { }

  ngOnInit(): void {
  //   // const spec = {
  //   //   data: {
  //   //       values: [
  //   //           {a: 'A', "b": 28}, {a: 'B', b: 55}, {a: 'C', b: 43}              
  //   //       ],
  //   //       name: 'source'
  //   //   },
  //   //   selection: {
  //   //     a: {type: 'single'}
  //   //   },
  //   //   mark: 'bar', 
  //   //   encoding: {
  //   //       x: {field: 'a', type: 'ordinal'},
  //   //       y: {field: 'b', type: 'quantitative'}
  //   //   }
  //   // };  

  //   // const options: VisOptions = {
  //   //   xLabel: 'x',
  //   //   yLabel: 'y',
  //   //   xType: 'quantitative',
  //   //   yType: 'quantitative',
  //   //   zoomToFit: false,
  //   //   fontSize: 11,
  //   //   ...opts,
  //   // };

  //   // const encodings: any = {
  //   //   x: {
  //   //     field: 'x',
  //   //     type: options.xType,
  //   //     title: options.xLabel,
  //   //   },
  //   //   y: {
  //   //     field: 'y',
  //   //     type: options.yType,
  //   //     title: options.yLabel,
  //   //     // scale: { zero: false },
  //   //   },
  //   //   color: {
  //   //     field: 'series',
  //   //     type: 'nominal',
  //   //     legend: { values: data.series, orient: 'bottom', offset: 0 }
  //   //   },
  //   // };


  //   const spec: VisualizationSpec = {

     
  //     padding: 0,
  //     autosize: {
  //       type: 'fit',
  //       contains: 'padding',
  //       resize: true,
  //     },
  //     config: {
  //       // axis: {
  //       //   labelFontSize: options.fontSize,
  //       //   // titleFontSize: options.fontSize,
  //       // },
  //       // text: { fontSize: options.fontSize },
  //       // legend: {
  //       //   labelFontSize: options.fontSize,
  //       //   titleFontSize: options.fontSize,
  //       // }
  //     },
  //     data:  {
  //             values: [
  //                 {a: 'A', "b": 28}, {a: 'B', b: 55}, {a: 'C', b: 43}              
  //             ],
  //             name: 'source'
  //         },
  //     layer: [
  //       {
  //         // Render the main line chart
  //         mark: {
  //           type: 'line',
  //           clip: true,
  //         },
  //         encoding: {
  //                 x: {field: 'a', type: 'ordinal'},
  //                 y: {field: 'b', type: 'quantitative'}
  //             }
  //       },
  //       {
  //         // Render invisible points for all the the data to make selections
  //         // easier
  //         mark: { type: 'point' },
  //         // encoding: encodings,
  //         // If a custom domain is set, filter out the values that will not
  //         // fit we do this on the points and not the line so that the line
  //         // still appears clipped for values outside the domain but we can
  //         // still operate on an unclipped set of points.
  //         transform: undefined,
  //         selection: {
  //           nearestPoint: {
  //             type: 'single',
  //             on: 'mouseover',
  //             nearest: true,
  //             empty: 'none',
  //             encodings: ['x'],
  //           },
  //         },      
  //       }        
  //     ],
  //   };
    

  //   const embedOpts = {
  //     actions: false,
  //     mode: 'vega-lite' as Mode,
  //     defaultStyle: false,
  //   };
  
  //   embed('#vis',spec, embedOpts);    
    
  }

  selectChart(event: any, chartType: GOOGLE_CHART_TYPE){
    if(event.isUserInput){  
      this.selectedChartType = chartType;  
    }
  }
}
